<script>
import { layoutComputed } from '@/state/helpers';
import { layoutMethods } from '@/state/helpers';

import NavBar from '@/components/nav-bar';
import SideBar from '@/components/side-bar';
import RightBar from '@/components/right-bar';

export default {
  components: {
    NavBar,
    SideBar,
    RightBar,
  },
  created: function () {
    this.toggleMenu();

    document.body.removeAttribute('data-layout', 'horizontal');
    document.body.removeAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-layout-size', 'boxed');
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById('preloader').style.display = 'block';
      document.getElementById('status').style.display = 'block';

      setTimeout(function () {
        document.getElementById('preloader').style.display = 'none';
        document.getElementById('status').style.display = 'none';
      }, 2500);
    } else {
      document.getElementById('preloader').style.display = 'none';
      document.getElementById('status').style.display = 'none';
    }
  },
  methods: {
    ...layoutMethods,
    toggleMenu() {
      if (this.menuCondensed) {
        document.body.classList.add('sidebar-enable');
        document.body.classList.add('vertical-collpsed');
      } else {
        document.body.classList.remove('sidebar-enable');
        document.body.classList.remove('vertical-collpsed');
      }
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled');
    },
    hideRightSidebar() {
      document.body.classList.remove('right-bar-enabled');
    },
    dismissNotification() {
      this.lastCodeDismissed = this.notification.code;
    },
  },
  computed: {
    ...layoutComputed,
    notification() {
      let appInfos = this.$store.state.cache.appInfos;

      if (appInfos == null) return null;

      return appInfos.notification;
    },
    showNotification() {
      if (this.notification == null) return false;

      let code = this.notification.code ?? '';
      if (code.length == 0) return false;

      if (this.notificationMessage.length == 0) return false;

      return this.lastCodeDismissed != this.notification.code;
    },
    notificationMessage() {
      if (this.notification == null) return '';

      if (this.$i18n.locale.toLowerCase() == 'fr') {
        return this.notification.messageFR ?? '';
      } else {
        return this.notification.messageEN ?? '';
      }
    },
    notificationVariant() {
      if (this.notification == null) return 'warning';

      if (this.notification.variant == null) return 'warning';

      return this.notification.variant.toLowerCase();
    },
    applicationConfig: {
      get() {
        return this.$store.getters['localstorage/getByCode'](
          'applicationConfig'
        );
      },
      set(value) {
        this.$store.dispatch('localstorage/setByCode', {
          code: 'applicationConfig',
          config: value,
        });
      },
    },
    lastCodeDismissed: {
      get() {
        if (this.applicationConfig == null) return '';

        return this.applicationConfig.lastCodeDismissed;
      },
      set(value) {
        this.applicationConfig = {
          ...this.applicationConfig,
          lastCodeDismissed: value,
        };
      },
    },
  },
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <NavBar />
      <SideBar
        :is-condensed="menuCondensed"
        :type="leftSidebarType"
        :width="layoutWidth"
      />
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <div style="margin-top: 58px"></div>
        <transition name="slideup">
          <div v-if="showNotification" class="d-flex page-content-no-padding">
            <b-alert
              show
              dismissible
              @dismissed="dismissNotification"
              :variant="notificationVariant"
              class="d-flex w-100 justify-content-center mb-0"
            >
              {{ this.notificationMessage }}
            </b-alert>
          </div>
        </transition>

        <div
          style="height: calc(100vh - 58px); display: flex; padding: 0 0 0 8px"
          class="page-content customScrollbarAlwaysOn"
        >
          <!-- Start Content-->
          <div
            style="
              display: flex;
              flex-direction: column;
              overflow-y: scroll;
              overflow-x: hidden;
              padding-top: 15px;
            "
            class="container-fluid"
          >
            <slot />
          </div>
        </div>
      </div>
      <RightBar />
    </div>
  </div>
</template>

<style scoped>
.slideup-leave-active,
.slideup-enter-active {
  transition: 0.75s;
  max-height: 50px;
}
.slideup-leave-to {
  transform: translateY(-50px);
  max-height: 0;
}
</style>